// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2EHqj","header":"MergedInvoice_header__2RwaP"};